import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

declare global {
  interface Window {
    fbq: (...args: any[]) => void;
    _fbq: any;
  }
}

const FB_PIXEL_ID = '1553329215910337';

export const FacebookPixel = () => {
  const location = useLocation();
  const initialized = useRef(false);
  const lastTrackedPath = useRef<string | null>(null);

  useEffect(() => {
    // Initialize Facebook Pixel only once
    if (typeof window !== 'undefined' && !initialized.current) {
      initialized.current = true;
      
      // Create fbq function
      const fbq = function(...args: any[]) {
        if ((fbq as any).callMethod) {
          (fbq as any).callMethod.apply(fbq, args);
        } else {
          (fbq as any).queue.push(args);
        }
      };
      
      window.fbq = fbq;
      window._fbq = fbq;
      (fbq as any).push = fbq;
      (fbq as any).loaded = true;
      (fbq as any).version = '2.0';
      (fbq as any).queue = [];

      // Load the Facebook Pixel script
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(script);

      // Initialize pixel and track first PageView
      window.fbq('init', FB_PIXEL_ID);
      window.fbq('track', 'PageView');
      lastTrackedPath.current = location.pathname;
      
      console.log('[FB Pixel] Initialized with ID:', FB_PIXEL_ID);
    }
  }, [location.pathname]);

  // Track page views on route change (but not on initial load)
  useEffect(() => {
    if (
      typeof window !== 'undefined' && 
      window.fbq && 
      initialized.current &&
      lastTrackedPath.current !== null &&
      lastTrackedPath.current !== location.pathname
    ) {
      window.fbq('track', 'PageView');
      lastTrackedPath.current = location.pathname;
      console.log('[FB Pixel] PageView tracked:', location.pathname);
    }
  }, [location.pathname]);

  return (
    <noscript>
      <img 
        height="1" 
        width="1" 
        style={{ display: 'none' }}
        src={`https://www.facebook.com/tr?id=${FB_PIXEL_ID}&ev=PageView&noscript=1`}
        alt=""
      />
    </noscript>
  );
};

// Helper function to track custom events
export const trackFBEvent = (eventName: string, params?: Record<string, any>) => {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', eventName, params);
  }
};

// Common event helpers
export const trackLead = (params?: { content_name?: string; value?: number }) => {
  trackFBEvent('Lead', params);
};

export const trackContact = () => {
  trackFBEvent('Contact');
};

export const trackCompleteRegistration = (params?: { content_name?: string; value?: number }) => {
  trackFBEvent('CompleteRegistration', params);
};
